import { render, staticRenderFns } from "./TagWithKeyAdder.vue?vue&type=template&id=a23d54b2"
import script from "./TagWithKeyAdder.vue?vue&type=script&lang=js"
export * from "./TagWithKeyAdder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports